<template>
  <div>
    <v-nav></v-nav>
    <Row>
      <i-col span="6">
        <Menu :active-name="activeName"
              :open-names="['form']"
              style="width: 100%;height: 100vh;"
              class="suggest-menu"
              @on-select="(key) => activeName =key">
          <Menu-item name="feedback">
            Feedback
          </Menu-item>
          <Submenu name="form">
            <template slot="title">
              Forum Issues
            </template>
            <Menu-item name="suggestion">
              Summary of all Suggestions
            </Menu-item>
            <Menu-item name="error">
              Summary of all Errors
            </Menu-item>
            <Menu-item name="compliment">
              Summary of all Compliments
            </Menu-item>
          </Submenu>
          <Menu-item name="github">
            Github Issues
          </Menu-item>
        </Menu>
      </i-col>
      <i-col span="18">
        <div style="width: 100%;height: 100vh;overflow: auto;padding: 16px 16px 16px 16px">
          <git-hub-list v-if="activeName === 'github'"></git-hub-list>
          <forum-issue-list v-if="activeName === 'suggestion'" suggest-type="01"></forum-issue-list>
          <forum-issue-list v-if="activeName === 'error'" suggest-type="02"></forum-issue-list>
          <forum-issue-list v-if="activeName === 'compliment'" suggest-type="03"></forum-issue-list>
          <feed-back v-if="activeName === 'feedback'" @submitSuccess="submitSuccess"></feed-back>
          <div style="height: 50px"></div>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
// zhouhan@cibr.ac.cn 2023/3/30 10:36

import VNav from "../public/v-nav.vue";
import GitHubList from "./gitHubList.vue";
import ForumIssueList from "./forumIssueList.vue";
import FeedBack from "./feedBack.vue";

export default {
  name: "",
  components: {FeedBack, ForumIssueList, GitHubList, VNav},
  data() {
    return {
      loading: false,
      activeName: "feedback"
    }
  },
  mounted() {
    // this.initPage();
  },
  methods: {
    submitSuccess(suggestType){
      if (suggestType === "01"){
        this.activeName = "suggestion";
      }
      if (suggestType === "02"){
        this.activeName = "error";
      }
      if (suggestType === "03"){
        this.activeName = "compliment";
      }
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {

    }
  }
}
</script>

<style scoped>

</style>